import moment, { Moment } from 'moment'
import { COLORS } from 'utils'

export const withDateColor = (date: string) => {
  if (!date) {
    return 'transparent'
  }

  if (isNaN(Number(date))) {
    return COLORS.error
  }

  return COLORS.black
}

export const rangeIsInvalid = (from: string, to: string) => {
  if (Number(from) >= Number(to)) {
    return true
  }

  return false
}

export const rangeIsInvalidNumber = (from: number, to: number) => {
  if (from >= to) {
    return true
  }

  return false

}

export const isEmptyOrBefore = (from: Moment, to: Moment) => {
  if (from.isValid() && to.isValid()) {
    return from.isSameOrBefore(to)
  }
  return false
}

export const isEmptyOrAfter = (from: Moment, to: Moment) => {
  if (from.isValid() && to.isValid()) {
    return from.isSameOrAfter(to)
  }
  return false
}

export const hasInvalidDate = (dates: string[]) => {
  return dates.find((date) => isNaN(Number(date)))
}
